import { lazy } from "react";
import { RouteObject, Outlet } from "react-router-dom";
import { SETTING_URL } from "setting/constants";
import {
  MAIL_TEMPLATE,
  USER_ASSIGNMENT,
  MANAGER_SETTING,
} from "setting/constants/route";
import LazyLoader from "base/components/LazyLoader";
import AdminGuard from "base/route-guard/AdminGuard";

const MailTemplatePage = LazyLoader(
  lazy(() => import("setting/pages/MailTemplatePage"))
);
const UserAssignmentPage = LazyLoader(
  lazy(() => import("setting/pages/UserAssignmentPage"))
);
const ManagerSettingPage = LazyLoader(
  lazy(() => import("setting/pages/ManagerSetting"))
);

const route: RouteObject = {
  path: SETTING_URL,
  element: (
    <AdminGuard>
      <Outlet />
    </AdminGuard>
  ),
  children: [
    {
      path: MAIL_TEMPLATE,
      element: <MailTemplatePage />,
    },
    {
      path: USER_ASSIGNMENT,
      element: <UserAssignmentPage />,
    },
    {
      path: MANAGER_SETTING,
      element: <ManagerSettingPage />,
    },
  ],
};

export default route;
